/**
 * Slack-style coloured chip for a single mount target.
 *
 * The chip is a self-contained presentational component. Removal is opt-in:
 * when ``onRemove`` is wired the chip renders an inline "x" that calls back
 * with the original target object so the parent can issue
 * ``removeAssetMount`` (catalog row) or pop the entry off a draft list
 * (configure dialog).
 */
import React from 'react';
import { X } from 'lucide-react';
import { targetClassName, targetLabel } from './MountTarget';

export default function MountChip({ target, onRemove, className = '' }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full ring-1 px-2 py-0.5 text-xs font-medium ${targetClassName(target)} ${className}`.trim()}
      title={targetLabel(target)}
    >
      <span className="truncate">{targetLabel(target)}</span>
      {onRemove ? (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove(target);
          }}
          aria-label={`Remove ${targetLabel(target)}`}
          className="-mr-0.5 rounded-full p-0.5 hover:bg-black/10"
        >
          <X className="h-3 w-3" aria-hidden />
        </button>
      ) : null}
    </span>
  );
}
